import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SingleDeliveryItem from './SingleDeliveryItem';
import { fToCurrency, mapItemsToDeliveries } from '@web/utils/src';
import { DeliveryType, OrderLineItem } from '@/types';
import { POrder } from '../OrderDetailsPage';

interface OrderDeliveriesTableProps {
  order: POrder;
  showComments: boolean;
}

interface FormattedDelivery {
  id: string;
  type: string;
  items: OrderLineItem[];
}

type FormattedDeliveries = FormattedDelivery[];

export default function OrderDeliveriesTable(props: OrderDeliveriesTableProps) {
  const { order, showComments } = props;
  const [deliveries, setDeliveries] = useState<FormattedDeliveries | []>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (!order) return;

    const formattedDeliveries: FormattedDeliveries =
      mapItemsToDeliveries(order);
    setDeliveries(formattedDeliveries);
  }, [order]);

  return (
    <div>
      <div className="bg-primary-yellow font-bd text-1-2 rounded-8-0 mb-2-0">
        <div className="flex justify-between p-1-0 border-b border-primary-black">
          <span>{t('checkout.total_net')}</span>
          <span className="w-[10%]">{fToCurrency(order.totalNet || 0)}</span>
        </div>
        <div className="flex justify-between p-1-0">
          <span>{t('checkout.total_gross')}</span>
          <div className="w-[10%]">
            {fToCurrency(order.orderTotalGross || 0)}
          </div>
        </div>
      </div>
      {deliveries.map((delivery, index) => {
        return (
          <div key={delivery.id} className="mb-1-0">
            <div className="mb-1-0">
              <p className="text-body1 font-bd">
                {delivery.type === DeliveryType.Pickup
                  ? t('order.pickup')
                  : t('order.delivery')}{' '}
                {index + 1}
              </p>
              {delivery.siloName && (
                <p className="text-body1 text-grey-80">{delivery.siloName}</p>
              )}
            </div>
            <div className="flex text-1-2 font-bd p-1-0 border-b-2 border-primary-black">
              <div className="w-[10%]">
                <span>{t('orders.amount')}</span>
              </div>
              <div className="w-full">
                <span>{t('orders.product_title')}</span>
              </div>
              <div className="w-[10%]">
                <span>{t('orders.amount')}</span>
              </div>
              <div className="w-[10%]">
                <span>{t('orders.price')}</span>
              </div>
            </div>
            {delivery.items.map((item: OrderLineItem) => {
              return <SingleDeliveryItem key={item.id} item={item} />;
            })}
            {delivery.comments && showComments && (
              <div className="mt-1-0">
                <p className="text-body1 text-grey-80 font-bd">
                  {t('order.comments')}
                </p>
                <p className="text-body1 text-grey-80 mt-1-0">
                  {delivery.comments}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
